const SPACE_COLOR_PALETTE = [
  'var(--space-color-1)',
  'var(--space-color-2)',
  'var(--space-color-3)',
  'var(--space-color-4)',
  'var(--space-color-5)',
  'var(--space-color-6)',
  'var(--space-color-7)',
  'var(--space-color-8)',
  'var(--space-color-9)',
  'var(--space-color-10)',
] as const

export const getSpaceColor = (roomId: string, index: number): string => {
  if (index >= 0) {
    return SPACE_COLOR_PALETTE[index % SPACE_COLOR_PALETTE.length]
  }

  let hash = 0
  for (let i = 0; i < roomId.length; i += 1) {
    hash = (hash << 5) - hash + roomId.charCodeAt(i)
    hash |= 0
  }
  return SPACE_COLOR_PALETTE[Math.abs(hash) % SPACE_COLOR_PALETTE.length]
}
